import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _UploadAlt(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m12 5 .707-.707L12 3.586l-.707.707zm-1 12a1 1 0 1 0 2 0zm7.707-6.707-6-6-1.414 1.414 6 6zm-7.414-6-6 6 1.414 1.414 6-6zM11 5v12h2V5z" }),
            React.createElement("path", { stroke: "currentColor", strokeWidth: 2, d: "M5 21h14" })));
}
const UploadAlt = forwardRef(_UploadAlt);
export { UploadAlt };
